import mqtt from 'mqtt';

const myMqtt = {

    reconnect_time_out: 5000,

    client: null,

    credentials_next_fetch_time: null,

    ping_interval: null,

    connect: function () {

        this.credentials_next_fetch_time = new Date((new Date()).getTime() + 0.2 * 60000);

        this.client = mqtt.connect(ws_address, {
            reconnectPeriod: this.reconnect_time_out,
            transformWsUrl: (url, options, client) => {
                console.debug('mqtt: connecting');
                client.options.username = mqtt_user.username;
                client.options.password = mqtt_user.password;
                return ws_address;
            }
        });

        this.client.on('close', () => {
            console.debug('mqtt: close');
            this.fetch_credentials();
        });

        this.ping_interval = setInterval(() => {
            console.debug('mqtt: ping');
            this.client.publish(`${site_prefix}/ping/${mqtt_user.username}`, '{"action":"ping"}');
        }, 15000)

    },

    fetch_credentials: function () {
        if (this.credentials_next_fetch_time > (new Date())) {
            return;
        }

        console.debug('mqtt: fetch credentials');

        fetch(`/api/data/${data_path}/mqtt.json`)
            .then((res) => {
                if (res.status === 403) {
                    location.href = '/login';
                }
                return res.json()
            }).then(
            json => {
                this.credentials_next_fetch_time = new Date((new Date()).getTime() + 0.2 * 60000);
                mqtt_user.username = json.mqtt_user.username;
                mqtt_user.password = json.mqtt_user.password;
            }
        ).catch(err => {
            throw err;
        });

    }




};

export default myMqtt;
